/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Demo from './pages/Demo';
import Login from './pages/Login';
import UpdateProfile from './pages/Register';
import DashboardPage from './pages/Dashboard';
import Help from './pages/Help';
import Logout from './pages/Logout';
import { getBaseUrl } from './utils/url';
import Task from './pages/task/Index';
import NotFound from './pages/NotFound';
import Payments from './pages/Payments';

import { Toaster } from './components/ui/toaster';

const App: React.FC = () => {
  return (
    <Router basename={getBaseUrl()}>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<UpdateProfile />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/help" element={<Help />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/task/:taskId" element={<Task />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </Router>
  );
};

export default App;
